<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">     
      
      <el-tag type="danger" closable @close="tagshow='false'" v-if="tagshow=='true'">温馨提示：如需在线上商城使用在线支付、线下支付功能，请分别对应下面的选项分别开启</el-tag>     
      <!----------------------------支付类型列表（lists start）----------------------------------->
      <div class="backborder1" style="margin-top:10px">
	      <el-table :data="paylists" v-loading="paylistsLoading" style="width:100%">
	      	  <el-table-column type="expand">
				  <template slot-scope="props">
	                  <el-table :data="props.row.children" v-if="props.row.children!=''">
	                      <el-table-column prop="name" label="名称"></el-table-column>
	                      <el-table-column label="LOGO" width="250" align="center">
	                          <template slot-scope="sscope">
	                              <img :src="sscope.row.logo" style="width:20%">
	                          </template>
	                      </el-table-column>
	                      <el-table-column prop="status" label="关闭/开启" width="150" align="center">
	                          <template slot-scope="sscope">
					              <el-switch active-color="#13ce66" inactive-color="#cccccc" v-model="paystatus[sscope.$index]"  @change="changestatus(sscope.$index,sscope.row)"></el-switch>
					          </template>
	                      </el-table-column>
	                      <el-table-column label="操作" width="150" align="center">
	                          <template slot-scope="sscope">
	                      	      <el-button type="primary" size="small" icon="el-icon-edit" circle @click="editpay(sscope.row)"></el-button>
	                      	      <el-button type="danger" size="small" icon="el-icon-delete" circle @click="delpay(sscope.row)"></el-button>
	                      	  </template>
	                      </el-table-column>
	                  </el-table>
	              </template>
			  </el-table-column>      	  
	          <el-table-column prop="name" label="支付类型" align="left"></el-table-column>
	          <el-table-column prop="status" label="关闭/开启" align="center" width="150">
		          <template slot-scope="scope">
		              <el-switch active-color="#13ce66" inactive-color="#cccccc" v-model="grounding[scope.$index]" @change="changeGrounding(scope.$index,scope.row)"></el-switch>
		          </template>
	          </el-table-column>          
	          <el-table-column label="操作" width="300" align="center">
		          <template slot-scope="scope">
		              <el-button type="primary" size="mini" icon="el-icon-plus" v-if="scope.$index == 0" circle @click="addPay()"></el-button>
		          </template>
	          </el-table-column>
	      </el-table>
      </div>
      <!----------------------------支付类型列表（lists end）----------------------------------->
          
      <!----------------------------添加在线支付（add pay start）--------------------------------->
      <el-dialog title="添加在线支付" :visible.sync="addPayDialog" width="35%" top="10vh">
      	  <el-form ref="pay" :model="pay" :rules="rules" label-width="100px" size="small">
      	      <el-col :span="24">
      	          <el-col :span="18">
		      	      <el-form-item label="支付方式" prop="type">
		              	  <el-select v-model="pay.type" placeholder="请选择支付类型" @change="selectPaytype">
				          	  <el-option v-for="(item,index) in payinfos" :label="item.name" :value="item.id" :key="index"></el-option>
				          </el-select>
		              </el-form-item>
	              </el-col>
      	      </el-col>
      	      <el-col :span="24" v-if="pay.logo!=''">
      	      	  <el-col :span="20">
	      	      	  <el-form-item prop="logo" label="">
					  	  <img  :src="pay.logo" alt="" v-model="pay.logo" style="width:20%;">
  					  </el-form-item>
				  </el-col>
      	      </el-col>
      	      
      	      <!-----  支付宝  ------->
      	      <el-col :span="24" v-if="pay.type==1">
      	      	  <el-col :span="18">
	      	      	  <el-form-item label="appid">
					  	  <el-input placeholder="请输入appid" size="25" v-model="pay.appid"></el-input>
  					  </el-form-item>
				  </el-col>
				  <el-col :span="18">
	      	      	  <el-form-item label="公钥">
					  	  <el-input type="textarea" :autosize={minRows:2,maxRows:4} placeholder="请输入公钥" v-model="pay.public_key"></el-input>
  					  </el-form-item>
				  </el-col>
				  <el-col :span="18">
	      	      	  <el-form-item label="私钥">
					  	  <el-input type="textarea" :autosize={minRows:2,maxRows:4} placeholder="请输入公钥" v-model="pay.private_key"></el-input>
  					  </el-form-item>
				  </el-col>
      	      </el-col>
			  <!-----  微信支付  ------->
      	      <el-col :span="24" v-if="pay.type==2">
      	      	  <el-col :span="18">
	      	      	  <el-form-item label="appid">
					  	  <el-input placeholder="请输入appid" size="25" v-model="pay.appid"></el-input>
  					  </el-form-item>
				  </el-col>
				  <el-col :span="18">
	      	      	  <el-form-item label="商户号">
					  	  <el-input placeholder="请输入微信商户号" size="25" v-model="pay.mch_id"></el-input>
  					  </el-form-item>
				  </el-col>
				  <el-col :span="18">
	      	      	  <el-form-item label="私钥">
					  	  <el-input type="textarea" :autosize={minRows:2,maxRows:4} placeholder="请输入密钥" v-model="pay.private_key"></el-input>
  					  </el-form-item>
				  </el-col>
      	      </el-col>
      	  </el-form>
      	  
      	  <div style="width:100%;height:30px;float:left"></div>
      	  <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="addPayDialog = false">取 消</el-button>
              <el-button size="small" type="primary" :loading="addLoading" @click="addPaysave">保 存</el-button>
          </div>
      </el-dialog>
      <!----------------------------添加在线支付（add pay end）----------------------------------->
      
      <!----------------------------编辑在线支付（edit pay start）--------------------------------->
      <el-dialog title="编辑在线支付" :visible.sync="editPayDialog" width="35%" top="10vh">
      	  <el-form ref="editpay" :model="editpay" :rules="rules" label-width="100px" size="small">
      	      <el-col :span="24">
      	          <el-col :span="18">
		      	      <el-form-item label="支付方式" prop="type">
		              	  <el-select v-model="update.type" placeholder="请选择支付类型" @change="selectPaytype" disabled>
				          	  <el-option v-for="(item,index) in payinfos" :label="item.name" :value="item.id" :key="index"></el-option>
				          </el-select>
		              </el-form-item>
	              </el-col>
      	      </el-col>
      	      <el-col :span="24" v-if="update.logo!=''">
      	      	  <el-col :span="20">
	      	      	  <el-form-item prop="logo" label="">
					  	  <img  :src="update.logo" alt="" v-model="update.logo" style="width:20%;">
  					  </el-form-item>
				  </el-col>
      	      </el-col>
      	      <!-----  支付宝  ------->
      	      <el-col :span="24" v-if="update.type==1">
      	      	  <el-col :span="18">
	      	      	  <el-form-item label="appid">
					  	  <el-input placeholder="请输入appid" size="25" v-model="update.appid"></el-input>
  					  </el-form-item>
				  </el-col>
				  <el-col :span="18">
	      	      	  <el-form-item label="公钥">
					  	  <el-input type="textarea" :autosize={minRows:2,maxRows:4} placeholder="请输入公钥" v-model="update.public_key"></el-input>
  					  </el-form-item>
				  </el-col>
				  <el-col :span="18">
	      	      	  <el-form-item label="私钥">
					  	  <el-input type="textarea" :autosize={minRows:2,maxRows:4} placeholder="请输入公钥" v-model="update.private_key"></el-input>
  					  </el-form-item>
				  </el-col>
      	      </el-col>
			  <!-----  微信支付  ------->
      	      <el-col :span="24" v-if="update.type==2">
      	      	  <el-col :span="18">
	      	      	  <el-form-item label="appid">
					  	  <el-input placeholder="请输入appid" size="25" v-model="update.appid"></el-input>
  					  </el-form-item>
				  </el-col>
				  <el-col :span="18">
	      	      	  <el-form-item label="商户号">
					  	  <el-input placeholder="请输入微信商户号" size="25" v-model="update.mch_id"></el-input>
  					  </el-form-item>
				  </el-col>
				  <el-col :span="18">
	      	      	  <el-form-item label="私钥">
					  	  <el-input type="textarea" :autosize={minRows:2,maxRows:4} placeholder="请输入密钥" v-model="update.private_key"></el-input>
  					  </el-form-item>
				  </el-col>
      	      </el-col>
      	  </el-form>
      	  
      	  <div style="width:100%;height:30px;float:left"></div>
      	  <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="editPayDialog = false">取 消</el-button>
              <el-button size="small" type="primary" :loading="editLoading" @click="editPaysave">保 存</el-button>
          </div>
      </el-dialog>
      <!----------------------------编辑在线支付（edit pay end）----------------------------------->
          
  </div>
  </transition> 
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Setting/index",
      transitionshow:true,
      addPayDialog: false, //添加支付方式窗口
      editPayDialog:false, //编辑支付方式窗口
      paylistsLoading:false, //支付列表预加载
      addLoading:false, //添加在线支付预加载
      editLoading:false, //编辑在线支付预加载
      
      paylists: [], //支付列表
      grounding: [], //在线支付开启开关
      paystatus: [], //支付类型开关
      payinfos: [], //支付信息类型列表
	  pay: { //在线支付表单
	  	  act:'addpay',
	  	  token:this.$cookies.get('token'),
	  	  logo:'',
	  	  appid:'',
	  	  public_key:'',
	  	  private_key:'',
		  mch_id:'',
	  	  type:'',
	  },
	  update: {
	  	  act:'updatepay',
	  	  token:this.$cookies.get('token'),
	  	  id:'',
	  	  logo:'',
	  	  appid:'',
	  	  public_key:'',
	  	  private_key:'',
		  mch_id:'',
	  	  type:'',
	  },
	  
	  /** 验证新增、编辑在线支付方式表单 **/
	  rules: {
	  	  type: [ //支付方式
              { required: true, message: '请选择支付方式', trigger: 'blur' },
          ],
	  },
	  tagshow:'true',
	  isxiaoye: false,
    }  
  },
  mounted(){
      this.getPaylists(); //获取支付信息
      this.getPayinfos(); //获取支付类型信息列表
	  this.getxiaoye(); //获取代理商是否是系统小也支付的合作代理商  
  },
  methods:{
	  /** 获取代理商是否有小也支付的权限 **/
	  getxiaoye() {
		  var resource = this.$resource(this.url);
          resource.save({ act:'isagentxiaoye',token:this.$cookies.get('token')}).then((res) => {
          	  if(res.data.Result>0){
              	  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  var result=JSON.parse(Base64.decode(res.data.Data));
				  result.istrue==1 ? this.isxiaoye=true : this.isxiaoye=false;
              }
          }).catch((res) => {
          	  this.$message.error(this.GLOBAL.errortext);
          });
	  },

	  /** 打开小也审核管理 **/
	  goxiaoye() {
		  this.$emit('listenchild',{name:'小也用户审核管理',url:'paysettingxiaoye'});
	  },

  	  /** 获取支付信息列表 **/
      getPaylists() {
      	  this.paylistsLoading=true;
      	  var resource = this.$resource(this.url);
          resource.save({ act:'getpaylists',token:this.$cookies.get('token')}).then((res) => {
          	  if(res.data.Result>0){
              	  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.paylistsLoading=false;
              }else{
                  var _this=this;
                  this.paylists=JSON.parse(Base64.decode(res.data.Data));
                  this.paylists.forEach(function(e,index){
                  	  e.status==0 ? _this.grounding.splice(index,1,false) : _this.grounding.splice(index,1,true);
			      });
			      this.paylists.forEach(function(e,index) {
			      	  if(e.children!=undefined) {
			      	  	  e.children.forEach(function(n,i) {
			          	  	  n.status==0 ? _this.paystatus.splice(i,1,false) : _this.paystatus.splice(i,1,true);
			          	  });
			      	  }
			      });
                  this.paylistsLoading=false;
              }
          }).catch((res) => {
          	  this.$message.error(this.GLOBAL.errortext);
          	  this.paylistsLoading=false;
          });
      },
      
      /** 获取支付信息类型列表 **/
      getPayinfos() {
      	  var resource = this.$resource(this.url);
	      resource.save({act:'getpayinfos',token:this.$cookies.get('token')}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	          }else {
	          	  this.payinfos=JSON.parse(Base64.decode(res.data.Data));
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      
      /** 开启/关闭支付类型开关 **/
      changeGrounding(index,item) {
	      var status=0;
	      this.grounding[index] ? status=1 : '';
	      
	      var resource = this.$resource(this.url);
	      resource.save({act:'changetypestatus',type:item.type,status:status,token:this.$cookies.get('token')}).then((res) => {
	          if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	          }else {
	          	this.getPaylists();
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      /** 添加线上支付 **/
      addPay() {
	  	  this.pay.logo='';
	  	  this.pay.appid='';
	  	  this.pay.public_key='';
	  	  this.pay.private_key='';
		  this.pay.mch_id='';
	  	  this.pay.type='';
      	  this.addPayDialog=true;
      },
      
      /** 选择支付方式 **/  
      selectPaytype(val) {
          var logo=this.payinfos[val]['logo'];
          this.pay.type=val;
          this.pay.logo=logo;
      },
      
      /** 开启/关闭支付类表开关 **/
      changestatus(index,val) {
          var status=0;
	      val.status==0 ? status=1 : '';
	      
	      var resource = this.$resource(this.url);
	      resource.save({act:'changepaystatus',id:val.id,status:status,token:this.$cookies.get('token')}).then((res) => {
	          if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      /** 上传图片开始 **/

      /** 上传图片结束 **/
      
      /** 保存在线支付方式 **/
      addPaysave() {
          this.addLoading=true;
          var resource = this.$resource(this.url);
	      resource.save(this.pay).then((res) => {
	      	  if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	              this.addLoading=false;
	          }else{
	              this.$message.success("保存支付设置成功！");
	              this.addPayDialog=false;
	              this.addLoading=false;
	              this.getPaylists();
	          }
	      }).catch((res) => {
	      	  this.$message.error(this.GLOBAL.errortext);
	          this.addLoading=false;
	          this.addPayDialog=false;
	      });
      },
      
      /** 删除支付方式 **/  
      delpay(item) {
          this.$confirm('删除该支付方式会影响线上商城支付，您是否要删除 '+item.name+' ?', '提示', { type: 'warning' })
              .then(() => {
	              var resource = this.$resource(this.url);
	              resource.save({ act:'delpays',id:item.id,token:this.$cookies.get('token')})
	                  .then((res) => {
	                  if(res.data.Result>0){
	                      if(res.data.Result=='70001') this.$router.push('/login')
	                      this.$message.error(res.data.Message);
	                  }else{
	                      this.$message.success('成功删除了' + item.name + '该支付方式！');
	                      this.getPaylists();
	                  }
                  }).catch((res) => {
                      this.$message.error(this.GLOBAL.errortext);
                  });
              }).catch(() => {
                  this.$message.info('已取消操作!');
              });
      },
      
      /** 获取支付信息 **/
      editpay(item) {
		  if(item.type==3) {this.goxiaoye();return false;}
          this.update.id=item.id;
          this.update.type=item.type;
          this.update.logo=item.logo;
          this.update.appid=item.appid;
          this.update.public_key=item.public_key;
          this.update.private_key=item.private_key;
		  this.update.mch_id=item.mch_id;
          this.editPayDialog=true;
      },
      
      /** 保存编辑支付信息 **/
      editPaysave() {
		  if(item.type==3) {this.goxiaoye();return false;}
      	  this.editLoading=false;
          var resource = this.$resource(this.url);
	      resource.save(this.update).then((res) => {
	      	  if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.addLoading=false;
	          }else{
	              this.$message.success("保存修改支付设置成功！");
	              this.editPayDialog=false;
	              this.editLoading=false;
	              this.getPaylists();
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	          this.editLoading=false;
	          this.editPayDialog=false;
	      });
      },
        
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/mall/Paysetting.vue